<span class="mat-content">
  <ng-content select="mat-panel-title"></ng-content>
  <ng-content select="mat-panel-description"></ng-content>
  <ng-content></ng-content>
</span>
<span [@indicatorRotate]="_getExpandedState()" *ngIf="_showToggle()"
      class="mat-expansion-indicator"></span>
